export interface SupportSearchEntry {
  title: string;
  href: string;
  description: string;
  section: string;
}

const STOPWORDS = new Set([
  "a",
  "an",
  "and",
  "are",
  "can",
  "do",
  "does",
  "for",
  "how",
  "i",
  "in",
  "is",
  "it",
  "my",
  "of",
  "on",
  "or",
  "the",
  "to",
  "what",
  "when",
  "where",
  "which",
  "who",
  "why",
  "with",
  "you",
]);

const TITLE_WORD_SCORE = 3;
const SECTION_WORD_SCORE = 2;
const DESCRIPTION_WORD_SCORE = 1;
const TITLE_PHRASE_BONUS = 5;

export function searchTerms(query: string): string[] {
  return query
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((word) => word.length > 0 && !STOPWORDS.has(word));
}

function wordMatches(haystack: string, term: string): boolean {
  return haystack.split(/[^a-z0-9]+/).some((word) => word.startsWith(term));
}

function entryScore(entry: SupportSearchEntry, terms: string[], phrase: string): number {
  const title = entry.title.toLowerCase();
  const section = entry.section.toLowerCase();
  const description = entry.description.toLowerCase();
  let score = title.includes(phrase) ? TITLE_PHRASE_BONUS : 0;
  for (const term of terms) {
    if (wordMatches(title, term)) score += TITLE_WORD_SCORE;
    else if (wordMatches(section, term)) score += SECTION_WORD_SCORE;
    else if (wordMatches(description, term)) score += DESCRIPTION_WORD_SCORE;
  }
  return score;
}

export function rankSupportEntries(
  query: string,
  entries: ReadonlyArray<SupportSearchEntry>,
  limit: number,
): SupportSearchEntry[] {
  const terms = searchTerms(query);
  if (terms.length === 0) return [];
  const phrase = query.trim().toLowerCase();
  return entries
    .map((entry) => ({ entry, score: entryScore(entry, terms, phrase) }))
    .filter(({ score }) => score > 0)
    .sort((left, right) => right.score - left.score)
    .slice(0, limit)
    .map(({ entry }) => entry);
}
